<script setup lang="ts">
import {computed} from "vue";
import VitaLogo from "capitalist-shared/src/icons/payout/pagsmile/vita.png";

const props = defineProps({
  height: {
    type: Number,
    default: 25
  }
})

const height = computed(() => props.height ? props.height : 2)
const width = computed(() => height.value * 112 / 100)

</script>

<template>
  <img :src=VitaLogo alt="Vita" :width="width" :height="height" />
</template>

<style scoped lang="less">

</style>
